
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Siren } from "../../../shared/ConfirmDialog";
import { Checkbox, FormControl, FormGroup, TextAreaInput, TextInput } from "@rivtn/noseur";
import { BaseService, IInterestsAndAi, MemberService, SanitizedResponse } from "../../../../services";

function InterestsAndAi() {

    const memberService = MemberService.getInstance();
    const labels = i18nManager.Labels.account.manage_account.interests_ai;
    const [interestsAndAi, setInterestsAndAi] = React.useState<IInterestsAndAi>();

    React.useEffect(() => {
        memberService.getInterestsAndAi(true).then(({ sanitized }: SanitizedResponse<IInterestsAndAi>) => {
            setInterestsAndAi(sanitized);
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.manage_account.title} - {labels.title}</span>
            <span className="desc">{labels.desc}</span>
        </div>
        <div className="interests-ai">
            <FormGroup scheme={Schemes.OMNEHOST} className="form" style={{ marginTop: 20 }}>
                <Checkbox checked={interestsAndAi?.use_data_to_train_ai} label={labels.use_data_to_train_omnehost} onChange={(e: any) => {
                    updateInterestAndAi({ ...interestsAndAi, use_data_to_train_ai: e.checked });
                }} />
                <Checkbox checked={interestsAndAi?.use_interest_to_guide_ai} label={labels.use_interests_to_guide_media_gen} onChange={(e: any) => {
                    updateInterestAndAi({ ...interestsAndAi, use_interest_to_guide_ai: e.checked });
                }} />
                <FormControl isFieldset fill label={labels.your_interests}>
                    <TextAreaInput fill defaultValue={interestsAndAi?.interests?.join(", ")}
                        onInputComplete={(value) => updateInterestAndAi({ ...interestsAndAi, interests: value.split(",").map(i => i.trim()) })} />
                </FormControl>
                {Object.keys(labels.ai_gen_prompts).map((gen_prompt: string) => (<FormControl key={gen_prompt} isFieldset fill label={(labels.ai_gen_prompts as any)[gen_prompt]}>
                    <TextInput defaultValue={interestsAndAi?.ai_generation_prompts?.find((ap) => ap.id === gen_prompt)?.value}
                        onInputComplete={(value) => updateInterestAndAi({ ...interestsAndAi, ai_generation_prompts: [...(interestsAndAi?.ai_generation_prompts ?? []), { id: gen_prompt, value }] })} />
                </FormControl>))}
            </FormGroup>
        </div>
    </div>);

    function updateInterestAndAi(payload: any) {
        memberService.updateInterestsAndAi(payload).then(({ sanitized }: SanitizedResponse<IInterestsAndAi>) => {
            setInterestsAndAi(sanitized);
            Siren.alert(labels.update_success);
            // TODO use kyofuuc api to update it cache, instead of re calling the API
            memberService.getInterestsAndAi(true).then(({}: SanitizedResponse<IInterestsAndAi>) => {}).catch(BaseService.reportError);
        }).catch(BaseService.reportError);
    }

}

export default InterestsAndAi;
